import camelcaseKeys from "camelcase-keys";
import {
  addNote,
  getNoteDetail,
  getNoteList,
  getNoteListByCustomer,
  removeNote,
} from "services/apis/note";
import snakecaseKeys from "snakecase-keys";
const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doGetNoteList = createAsyncThunk(
  "note/doGetNoteList",
  async params => {
    const request = snakecaseKeys(params);
    const result = await getNoteList(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doGetNoteListByCustomer = createAsyncThunk(
  "note/doGetNoteListByCustomer",
  async params => {
    const request = camelcaseKeys(params);
    const result = await getNoteListByCustomer(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doGetNoteDetail = createAsyncThunk(
  "note/doGetNoteDetail",
  async params => {
    const request = snakecaseKeys(params);
    const result = await getNoteDetail(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doAddNote = createAsyncThunk("note/doAddNote", async params => {
  const request = snakecaseKeys(params);
  const result = await addNote(request);
  if (!result) {
    return;
  }
  return camelcaseKeys(result);
});

export const doRemoveNote = createAsyncThunk(
  "note/doRemoveNote",
  async params => {
    const request = snakecaseKeys(params);
    const result = await removeNote(request);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

const initialState = {
  isSaving: false,
  noteList: [],
  noteDetail: {},
};
const slice = createSlice({
  name: "note",
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [doAddNote.pending]: state => {
      state.isSaving = true;
    },
    [doAddNote.fulfilled]: state => {
      state.isSaving = false;
    },
    [doAddNote.rejected]: state => {
      state.isSaving = false;
    },
    [doRemoveNote.pending]: state => {
      state.isSaving = true;
    },
    [doRemoveNote.fulfilled]: state => {
      state.isSaving = false;
    },
    [doRemoveNote.rejected]: state => {
      state.isSaving = false;
    },
    [doGetNoteList.fulfilled]: (state, actions) => {
      state.noteList = actions.payload.data;
    },
  },
});

const { reducer } = slice;

export default reducer;

export const isSaving = createSelector(
  state => state.message.isSaving,
  isSaving => isSaving
);

export const fetchNoteList = createSelector(
  state => state.note.noteList,
  noteList => noteList
);
